<template>
    <page :tabs="tabs">
        <grid
            ref="grid"
            :fetch-callback="fetchCallback"
            :column-defs="columnDefs"
            grid-theme="ag-theme-alpine-report"
            :maxBlocksInCache="null"
        />
    </page>
</template>

<script>
    import API from '../../api';
    import { format, parseISO } from 'date-fns';
    import Grid from '../generic/grid/grid.vue';
    import { OWNER_STATEMENT_LOG_ENDPOINT } from '../../endpoints';
    import Page from '../generic/page/page.vue';
    import { mapGetters } from 'vuex';
    import multiLineCellRenderer from './multi-line-cell-renderer.vue';

    export default {
        components: {
            Grid,
            Page,
            multiLineCellRenderer,
        },
        data() {
            return {
                tabs: [
                    { title: 'Generation', active: false, route: '/app/owner-statement/list' },
                    { title: 'Logs', route: '/app/owner-statement/list/logs', active: true },
                ],
            };
        },
        computed: {
            ...mapGetters('header', ['userUnicodeDateFormat', 'userTimeFormat']),
            generationId() {
                return this.$route.query.generation_id;
            },
            columnDefs() {
                const columnDefs = [
                    {
                        field: 'created',
                        headerName: 'Created',
                        sort: 'desc',
                        valueFormatter: (params) => {
                            if (params.value) {
                                return format(
                                    parseISO(params.value),
                                    `${this.userUnicodeDateFormat} ${this.userTimeFormat}`
                                );
                            }
                            return '';
                        },
                        minWidth: 180,
                        maxWidth: 200,
                    },
                    {
                        field: 'initiated_by',
                        headerName: 'Initiated By',
                        minWidth: 200,
                    },
                ];
                if (!this.generationId) {
                    columnDefs.push({
                        field: 'from_date',
                        headerName: 'Statements Period',
                        cellRenderer: (params) => {
                            return `${format(parseISO(params.data.from_date), this.userUnicodeDateFormat)} - ${format(
                                parseISO(params.data.to_date),
                                this.userUnicodeDateFormat
                            )}`;
                        },
                        maxWidth: 220,
                        minWidth: 200,
                    });
                }
                return [
                    ...columnDefs,
                    {
                        field: 'owner_names',
                        headerName: 'Owners',
                        cellRenderer: 'multiLineCellRenderer',
                        minWidth: 200,
                        maxWidth: 300,
                        sortable: false,
                        autoHeight: true,
                    },
                    {
                        field: 'property_names',
                        headerName: 'Properties',
                        cellRenderer: 'multiLineCellRenderer',
                        minWidth: 160,
                        sortable: false,
                        autoHeight: true,
                    },
                    {
                        field: 'action',
                        type: 'badgeColumn',
                        headerName: 'Action',
                        minWidth: 120,
                        maxWidth: 120,
                        sortable: false,
                        resizable: false,
                        cellRendererParams: {
                            badgeSize: 0.84,
                            badgeVariant: ({ value }) => {
                                if (value === 'Generate' || value === 'Regenerate') return 'light';
                                else if (value === 'Publish') return 'success';
                                else if (value === 'Unpublish' || value === 'Delete') return 'light';
                            },
                        },
                    },
                ];
            },
        },
        methods: {
            fetchCallback({ offset, limit, sort, desc, search }) {
                return API.get(OWNER_STATEMENT_LOG_ENDPOINT(), {
                    params: {
                        offset: offset,
                        limit: limit,
                        sort: sort,
                        desc: desc,
                        search: search,
                        generation_id: this.generationId || null,
                    },
                });
            },
        },
        watch: {
            generationId() {
                console.log(this.generationId);
                this.$refs.grid.refreshDataSource();
            },
        },
    };
</script>
